import { render, staticRenderFns } from "./MessageForClientModal.vue?vue&type=template&id=5ba9d812&scoped=true&"
import script from "./MessageForClientModal.vue?vue&type=script&lang=js&"
export * from "./MessageForClientModal.vue?vue&type=script&lang=js&"
import style0 from "./MessageForClientModal.vue?vue&type=style&index=0&id=5ba9d812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba9d812",
  null
  
)

export default component.exports